<div *ngIf="loginOpen$ | async" class="grow--pos fill--pos fixed grid-max-width center z5 ms-xxlarge-t">
  <div class="relative ms-medium-t">
    <fin-login-form
      #loginForm
      clickOutsideException="fin-login-form"
      [fullScreen]="mobileOrTablet"
      (finClickOutside)="loginForm.closeDialog()"
    ></fin-login-form>
  </div>
</div>
<fin-login-widget #loginWidget [context]="context"></fin-login-widget>
